export enum CPCompanyMenuItem {
  DOCUMENTS = 'documents',
  TRANSFERS = 'transfers',
  INVOICES = 'invoices'
}
